import { render, staticRenderFns } from "./BiayaBankPph.vue?vue&type=template&id=21b6148a&scoped=true"
import script from "./BiayaBankPph.vue?vue&type=script&lang=js"
export * from "./BiayaBankPph.vue?vue&type=script&lang=js"
import style0 from "./BiayaBankPph.vue?vue&type=style&index=0&id=21b6148a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6148a",
  null
  
)

export default component.exports